<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1"></p>
<h2 class="title" id="calibre_pb_0">Dantons Tod</h2>
<p class="calibre1"></p>
<h4 class="subtitle">Ein Drama</h4>
<p class="calibre1"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0_split_001.vue?03e6b483